import { cloudFunction } from 'services/parse';
import { IPayments } from 'interfaces/payment';

export const addPaymentMethod = async (data: IPayments.IPaymentIntentItem,userId) => {
  // Format the data into required format
  const payload = { paymentMethod: { id: data.id },userId };
  return await cloudFunction('addPaymentMethod', payload);
};